'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var includedProductsInPanaceeComponent = exports.includedProductsInPanaceeComponent = {
    template: require('./included-products-in-panacee.html'),
    bindings: {
        product: '=',
        context: '<',
        quantityChanged: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["productService", function controller(productService) {
        'ngInject';

        var vm = this;
        vm.orderByProperty = 'name';
        vm.isOrderByDescending = false;
        vm.setOrder = setOrder;
        vm.panaceeQuantityChanged = panaceeQuantityChanged;
        vm.changeViewMode = changeViewMode;
        vm.getProductDiscounts = getProductDiscounts;
        vm.viewMode = window.localStorage.getItem('viewMode') || 'list';

        /* On quantity on changed */
        function panaceeQuantityChanged(product) {
            vm.productsQuantityChanged = true;
            vm.quantityChanged(product);
        }

        /* Save in localstorage when viewmode changed */
        function changeViewMode(viewMode) {
            window.localStorage.setItem('viewMode', viewMode);
            vm.viewMode = viewMode;
        }

        /* Order the products */
        function setOrder(propName) {
            if (vm.orderByProperty === propName) {
                vm.isOrderByDescending = !vm.isOrderByDescending;
            } else {
                vm.isOrderByDescending = false;
            }
            vm.orderByProperty = propName;
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/included-products-in-panacee.js
// module id = 962
// module chunks = 0